// Использование: Если имеется перевод с динамическими значениям, вбить в переводы текста с шаблоном {{value}}, где value ключ

export const replaceValuesInText = (
  text: string,
  values: { [key: string]: string | number },
) => {
  let result = text || "";

  Object.keys(values).forEach((key) => {
    result = result.replaceAll(`{{${key}}}`, String(values[key]));
  });

  return result;
};
